<div class="page-container">

    <div class="header-section">
        <h1>Inspection Types</h1>
        <button class="btn-primary" (click)="addNew()" [disabled]="!selectedCustomer">
            <span class="material-icons">add</span>
            Add New
        </button>
    </div>

    <div class="filter-section">
        <div style="display:flex; align-items:center; gap: 12px; flex-wrap: wrap;">
            <p-select [filter]="true" [options]="customers" optionLabel="title" [(ngModel)]="selectedCustomer"
                placeholder="Please Select Customer..." [style]="{ width: '280px' }"
                (ngModelChange)="onCustomerChange($event)">
            </p-select>

            <div class="filter-info" *ngIf="selectedCustomer">
                <span class="result-count">{{ gridView.total }} Inspection Types found</span>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="loading-container">
        <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
        <p>Loading inspection types...</p>
    </div>

    <div class="cards-grid" *ngIf="!loading && selectedCustomer">
        <div class="card" *ngFor="let item of gridView.data">
            <div class="card-header">
                <div class="card-icon">
                    <span class="material-icons">fact_check</span>
                </div>
                <div class="card-title-section">
                    <h3 class="card-title">{{ item.title || 'Inspection Type' }}</h3>
                </div>
                <div class="overview-card-actions">
                    <button type="button" class="card-icon-btn" (click)="toggleActionMenu(item, $event)"
                        [attr.aria-expanded]="isActionMenuOpen(item)" title="Inspection type actions">
                        <span class="material-icons">more_vert</span>
                    </button>
                    <div class="card-action-menu" *ngIf="isActionMenuOpen(item)" (click)="$event.stopPropagation()">
                        <button type="button" class="menu-action" (click)="closeActionMenu(); openDetails(item)">
                            <span class="material-icons">info</span>
                            Details
                        </button>
                        <button type="button" class="menu-action menu-action-danger"
                            (click)="closeActionMenu(); openDeleteDialog(item)">
                            <span class="material-icons">delete</span>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="info-grid-row">

                    <div class="info-row">
                        <span class="material-icons info-icon">title</span>
                        <div class="info-content">
                            <span class="info-label">Title</span>
                            <span class="info-value">{{ item.title }}</span>
                        </div>
                    </div>

                    <div class="info-row">
                        <span class="material-icons info-icon">percent</span>
                        <div class="info-content">
                            <span class="info-label">Percent Packed</span>
                            <span class="info-value">{{ item.percentPacked }}%</span>
                        </div>
                    </div>


                </div>
                <div class="info-row">
                    <span class="material-icons info-icon">verified</span>
                    <div class="info-content">
                        <span class="info-label">Available Inspection Steps</span>
                        <div class="status-badges">
                            <span class="status-badge" [class.active]="item.isDefect">
                                <span class="material-icons">{{ item.isDefect ? 'check_circle' : 'cancel'
                                    }}</span>
                                Defects
                            </span>
                            <span class="status-badge" [class.active]="item.isDocuments">
                                <span class="material-icons">{{ item.isDocuments ? 'check_circle' :
                                    'cancel' }}</span>
                                Documents
                            </span>
                            <span class="status-badge" [class.active]="item.isFactoryAudit">
                                <span class="material-icons">{{ item.isFactoryAudit ? 'check_circle' :
                                    'cancel' }}</span>
                                Factory Audit
                            </span>
                            <span class="status-badge" [class.active]="item.isIdenticalDesign">
                                <span class="material-icons">{{ item.isIdenticalDesign ? 'check_circle' :
                                    'cancel' }}</span>
                                IdenticalDesign
                            </span>
                            <span class="status-badge" [class.active]="item.isMeasurements">
                                <span class="material-icons">{{ item.isMeasurements ? 'check_circle' :
                                    'cancel' }}</span>
                                Measurements
                            </span>
                            <span class="status-badge" [class.active]="item.isPacking">
                                <span class="material-icons">{{ item.isPacking ? 'check_circle' :
                                    'cancel' }}</span>
                                Packing
                            </span>
                            <span class="status-badge" [class.active]="item.isProductDetails">
                                <span class="material-icons">{{ item.isProductDetails ? 'check_circle' :
                                    'cancel' }}</span>
                                Product Details
                            </span>
                            <span class="status-badge" [class.active]="item.isProductStatus">
                                <span class="material-icons">{{ item.isProductStatus ? 'check_circle' :
                                    'cancel' }}</span>
                                Product Status
                            </span>
                            <span class="status-badge" [class.active]="item.isRequirements">
                                <span class="material-icons">{{ item.isRequirements ? 'check_circle' :
                                    'cancel' }}</span>
                                Requirements
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-empty-state
        *ngIf="!loading && !selectedCustomer"
        icon="filter_alt_off"
        headline="Please select a customer"
        subline="Choose a customer to view inspection types.">
    </app-empty-state>

    <app-empty-state
        *ngIf="!loading && selectedCustomer && gridView.data.length === 0"
        icon="search_off"
        headline="No inspection types found"
        subline='Click "Add New" to create the first inspection type for this customer.'>
    </app-empty-state>

    <div class="pagination-section" *ngIf="!loading && selectedCustomer && gridView.total > 0">
        <p-paginator [totalRecords]="gridView.total" [rows]="gridState.take ?? 12" [first]="gridState.skip ?? 0" [rowsPerPageOptions]="[12, 24, 48]" (onPageChange)="pageChange($event)"></p-paginator>
        <span class="result-count pagination-range">{{ footerRangeLabel }}</span>
    </div>

    <ng-container *ngIf="deleteDialog">
        <p-dialog [modal]="true" [visible]="true" header="Delete User" (onHide)="toggleDeleteDialog()" [style]="{ width: '450px' }">
            <div class="dialog-content">
                <p>Are you sure you want to delete Inspection type <strong>{{ itemToDelete?.title }}</strong>?</p>
                <p class="dialog-warning-text">This action cannot be undone.</p>
            </div>
            <ng-template pTemplate="footer">
                <button class="btn-secondary" (click)="toggleDeleteDialog()">Cancel</button>
                <button class="btn-primary" (click)="confirmDelete()">
                    <span class="material-icons">delete</span>
                    Delete
                </button>
            </ng-template>
        </p-dialog>
    </ng-container>

</div>
